import { gql } from '@apollo/client';

export const GET_DEPENDENT_BY_ID = gql`
  query GetDependentByIdQuery($id: UUID) {
    getDependentById(id: $id) {
      id
      firstName
      lastName
      active
      dateOfBirth
      clExperience
      upcomingDeactivationDate
    }
  }
`;
